import Vue from 'vue'
import Vuex from 'vuex'

import actionWrapper from './actionWrapper'

import activityGoods from './modules/activityGoods'
import pop from './modules/pop'
import integral from './modules/integral'

Vue.use(Vuex)

const storeWrapper = store => {
  Object.keys(store.modules).forEach(moduleName => {
    const actions = store.modules[moduleName].actions
    store.modules[moduleName].actions = actionWrapper(actions, moduleName)
  })
  return store
}

export const store = new Vuex.Store(
  storeWrapper({
    modules: {
      activityGoods,
      pop,
      integral
    }
  })
)
